export const hqAddressFormData = {
    STREET: {
        id: "hq - Street address",
        name: "street",
        label: "Street Address",
    },
    APARTMENT: {
        id: "hq - Apartment",
        name: "apartment",
        label: "Apt / Unit #",
    },
    CITY: {
        id: "hq - City or Town",
        name: "city",
        label: "City / Town",
    },
    ZIP: {
        id: "hq - Postal code",
        name: "zip",
        label: "Postal Code",
    },
    COUNTRY: {
        id: "hq - Country",
        name: "country",
        label: "Country",
    },
};

export const mailingAddressFormData = {
    STREET: {
        id: "mail - Street address",
        name: "street",
        label: "Street Address",
    },
    APARTMENT: {
        id: "mail - Apartment",
        name: "apartment",
        label: "Apt / Unit #",
    },
    CITY: {
        id: "mail - City or Town",
        name: "city",
        label: "City / Town",
    },
    ZIP: {
        id: "mail - Postal code",
        name: "zip",
        label: "Postal Code",
    },
    COUNTRY: {
        id: "mail - Country",
        name: "country",
        label: "Country",
    },
};
